var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6667 20.8542H7.33333C3.9875 20.8542 2.0625 18.9292 2.0625 15.5833V6.41667C2.0625 3.07083 3.9875 1.14583 7.33333 1.14583H14.6667C18.0125 1.14583 19.9375 3.07083 19.9375 6.41667V15.5833C19.9375 18.9292 18.0125 20.8542 14.6667 20.8542ZM7.33333 2.52083C4.71167 2.52083 3.4375 3.795 3.4375 6.41667V15.5833C3.4375 18.205 4.71167 19.4792 7.33333 19.4792H14.6667C17.2883 19.4792 18.5625 18.205 18.5625 15.5833V6.41667C18.5625 3.795 17.2883 2.52083 14.6667 2.52083H7.33333Z",
    fill: "#A2ABB4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.9583 8.47917H15.125C13.7317 8.47917 12.6042 7.35167 12.6042 5.95833V4.125C12.6042 3.74917 12.9158 3.4375 13.2917 3.4375C13.6675 3.4375 13.9792 3.74917 13.9792 4.125V5.95833C13.9792 6.59083 14.4925 7.10417 15.125 7.10417H16.9583C17.3342 7.10417 17.6458 7.41583 17.6458 7.79167C17.6458 8.1675 17.3342 8.47917 16.9583 8.47917Z",
    fill: "#A2ABB4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11 12.6042H7.33333C6.9575 12.6042 6.64583 12.2925 6.64583 11.9167C6.64583 11.5408 6.9575 11.2292 7.33333 11.2292H11C11.3758 11.2292 11.6875 11.5408 11.6875 11.9167C11.6875 12.2925 11.3758 12.6042 11 12.6042Z",
    fill: "#A2ABB4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.6667 16.2708H7.33333C6.9575 16.2708 6.64583 15.9592 6.64583 15.5833C6.64583 15.2075 6.9575 14.8958 7.33333 14.8958H14.6667C15.0425 14.8958 15.3542 15.2075 15.3542 15.5833C15.3542 15.9592 15.0425 16.2708 14.6667 16.2708Z",
    fill: "#A2ABB4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableDocument);
export default __webpack_public_path__ + "static/media/table-document.6b672777cb4ba19dfa97f3539f29ecd3.svg";
export { ForwardRef as ReactComponent };